import React from "react"; // CHANGED: useState is not needed any more
import { MessageSquare, ArrowRight } from "lucide-react";
import { hasUnreadFrom } from "../../lib/ticketChats";
import styles from "./NeedHelpTickets.module.css";

// ADDED: status badge colours (the same helper the details screen uses).
const statusClass = (status) => {
  switch (status) {
    case "Open":
      return styles.statusOpen;
    case "In Progress":
      return styles.statusProgress;
    case "Reopened":
      return styles.statusReopened;
    case "Resolved":
      return styles.statusResolved;
    case "Closed":
      return styles.statusClosed;
    default:
      return styles.statusClosed;
  }
};

// The card shows: Ticket ID + status badge, the chat icon, Subject, a one-line
// Description and a "View" button.
// CHANGED: new props
//   selected   - true for the card the user clicked (shown highlighted)
//   onSelect   - called with the ticketId when the card is clicked
// `onView(ticketId)` opens the details screen.
// `onChatRead(ticketId)` tells the parent that the user has now read the
// admin's messages of this ticket (the parent updates its ticket list).
const NeedHelpTicketCard = ({
  ticket,
  selected = false,
  onSelect,
  onOpenChat, // CHANGED: replaces onChatRead
  onView,
}) => {
  // Dot on the chat icon: only for unread messages sent by the admin.
  // The user's own unread messages never count.
  const hasUnread = hasUnreadFrom(ticket.chats, "admin");

  return (
    <>
      {/* CHANGED: clicking the card selects (highlights) it */}
      <article
        className={`${styles.card} ${selected ? styles.cardSelected : ""}`}
        onClick={() => onSelect?.(ticket.ticketId)}
      >
        {/* Top row: Ticket ID + status badge on the left, chat icon on the
            right. REMOVED: the grey header band and the left icon. */}
        <div className={styles.cardTop}>
          <div className={styles.cardTopLeft}>
            <span className={styles.cardId}>{ticket.ticketId}</span>
            <span className={`${styles.status} ${statusClass(ticket.status)}`}>
              {ticket.status}
            </span>
          </div>
          <button
            type="button"
            className={styles.responseBtn}
            onClick={(e) => {
              e.stopPropagation();
              // CHANGED: opens the ticket details page, scrolled to the chat
              onOpenChat?.(ticket.ticketId);
            }}
            aria-label={hasUnread ? "Open chat (new messages)" : "Open chat"}
            title="Open chat"
          >
            <MessageSquare size={17} strokeWidth={1.9} aria-hidden="true" />
            {hasUnread && (
              <span className={styles.unreadDot} aria-hidden="true" />
            )}
          </button>
        </div>

        <div className={`${styles.cell} ${styles.subjectCell}`}>
          <span className={styles.label}>Subject</span>
          <span className={`${styles.value} ${styles.cardSubject} ${styles.oneLine}`}>
            {ticket.subject || "-"}
          </span>
        </div>

        {/* Description takes 50% width, View sits at the row's end */}
        <div className={styles.descRow}>
          <div className={`${styles.cell} ${styles.descHalf}`}>
            <span className={styles.label}>Description</span>
            <span className={`${styles.value} ${styles.oneLine}`}>
              {ticket.description || "-"}
            </span>
          </div>
          <button
            type="button"
            className={styles.viewBtn}
            onClick={(e) => {
              e.stopPropagation();
              onView?.(ticket.ticketId);
            }}
          >
            View
            <ArrowRight size={14} strokeWidth={2.2} aria-hidden="true" />
          </button>
        </div>
      </article>
    </>
  );
};

export default NeedHelpTicketCard;
